import { Injectable } from '@angular/core';

import { CookieService } from '@frontend/vanilla/core';

@Injectable({ providedIn: 'root' })
export class VCClientService {
    constructor(private cookieService: CookieService) {}
    isClient(): boolean {
        return ['pokervc', 'pokerwd'].includes(this.cookieService.get('NativeApp'));
    }

    isMobileApp(): boolean {
        return ['POKER', 'pokerwc'].includes(this.cookieService.get('NativeApp'));
    }

    isMacDesktop(): boolean {
        return this.cookieService.get('NativeApp') === 'pokermc';
    }

    isPlayTechClient() {
        const playTechClients = ['ipokervc', 'ipokermc', 'ipokeran', 'ipokerin'];
        return playTechClients.includes(this.cookieService.get('NativeApp'));
    }
}
